export default __webpack_public_path__ + "static/people-2-d323207eee31b400d8badb250db3f602.png";